import { render, staticRenderFns } from "./StorageOuKu.vue?vue&type=template&id=0891c163&scoped=true&"
import script from "./StorageOuKu.vue?vue&type=script&lang=js&"
export * from "./StorageOuKu.vue?vue&type=script&lang=js&"
import style0 from "./StorageOuKu.vue?vue&type=style&index=0&id=0891c163&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0891c163",
  null
  
)

export default component.exports